<form (ngSubmit)="onSubmit()" [formGroup]="form" novalidate>
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <mat-icon>view_list</mat-icon>
      Export Batches
    </h1>
  </section>
  <section mat-dialog-content>
    <mat-form-field>
      <mat-label>Start Date</mat-label>
      <input
        formControlName="start_date"
        matInput
        required
        [matDatepicker]="startDatepicker"
        />
      <mat-datepicker-toggle
        matSuffix
        [for]="startDatepicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #startDatepicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field>
      <mat-label>End Date</mat-label>
      <input
        formControlName="end_date"
        matInput
        required
        [matDatepicker]="endDatepicker"
        />
      <mat-datepicker-toggle
        matSuffix
        [for]="endDatepicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #endDatepicker></mat-datepicker>
      <mat-error> {{ form.controls.end_date.errors?.['dateRange'] }} </mat-error>
    </mat-form-field>
  </section>
  <section align="end" mat-dialog-actions>
    <button
      mat-button
      mat-dialog-close
      matTooltip="Cancel and close."
      type="button"
      >
      <mat-icon>cancel</mat-icon>
      Cancel
    </button>
    <button
      [disabled]="!form.valid || loading"
      mat-button
      matTooltip="Export date range."
      type="submit"
      >
      @if (!loading) {
        <mat-icon>file_download</mat-icon>
      }
      @if (loading) {
        <mat-spinner diameter="24"></mat-spinner>
      }
      Export
    </button>
  </section>
</form>
